// covered-by: frontends/carrie/src/ask-v2/pages/__tests__/AskV2ProjectPage.test.tsx
import { type AskPunttOpenItem } from "@mg/schemas/src/christo/askPunttOpenItems";

import i18n from "../../i18n/config";
import { claimOf } from "../review/rememberedSentence";

const TITLE_LIMIT = 80;

function recordedTitle(item: AskPunttOpenItem): string {
  const title = (item as { title?: unknown }).title;
  return typeof title === "string" ? title.trim() : "";
}

export function openItemShortNeeded(item: AskPunttOpenItem): string {
  const needed = item.needed.trim();
  if (item.kind !== "unjudged_finding") return needed;
  return claimOf(
    needed.length > 0
      ? needed
      : i18n.t("askV2.openItems.unjudgedFindingNoNeeded", { ns: "ui" }),
  );
}

function questionText(item: AskPunttOpenItem): string {
  return openItemShortNeeded(item);
}

function firstSentence(text: string): string {
  const sentence = text.split(/(?<=[.!?])\s+/)[0] ?? text;
  return sentence.trim();
}

function shorten(text: string): string {
  if (text.length <= TITLE_LIMIT) return text;
  const cut = text
    .slice(0, TITLE_LIMIT)
    .replace(/\s\S*$/, "")
    .replace(/[,;:]$/, "")
    .trim();
  return cut.length > 0 ? cut : text.slice(0, TITLE_LIMIT).trim();
}

// why: the type is already the group dropdown, and the rollup has no title column — a payload title wins, otherwise the first sentence of the question, never the kind label.
export function openItemRowTitle(item: AskPunttOpenItem): string {
  const titled = recordedTitle(item);
  if (titled.length > 0) return titled;
  const question = questionText(item);
  if (question.length === 0) return "";
  return shorten(firstSentence(question));
}
